// Real data scraped from https://www.taastrupfc.com/ (Februar 2026).
// Bemærk: træningstider er repræsentative — klubben offentliggør de fulde
// planer kvartalsvist i PDF-format hos Turneringsudvalget.

export const CLUB = {
  name: "TAASTRUP FC",
  founded: 2006,
  foundedNote: "Fusion af Tåstrup B70 og TIK 90 (samarbejde indledt 2001)",
  stadium: "Nybolig Park (Taastrup Idrætspark)",
  address: "Parkvej, 2630 Taastrup",
  phone: "31 90 30 20",
  email: "sekretaer@taastrupfc.com",
  tagline: "Fællesskab. Fodbold. Fremtid.",
  description:
    "Taastrup FC er en sammenlægning af Tåstrup B70 og TIK 90 — en proces der startede i 2001 og blev fuldført pr. 1. januar 2006. Vi er i dag en klub med over 1.000 medlemmer, hvor hele 94 % af medlemmerne i ungdomsafdelingen oplyser, at de er trygge ved og glade for at komme i klubben.",
  values: [
    {
      label: "Fællesskab",
      detail:
        "Vi vinder som ét hold — på banen og uden for. 1.000+ medlemmer i alle aldre.",
    },
    {
      label: "Udvikling",
      detail:
        "Bredde og talent under samme tag. Tidligere TFC-spillere som Jesper Lindstrøm har taget springet videre.",
    },
    {
      label: "Respekt",
      detail:
        "I Høje-Taastrup Kommune behandler vi alle ledere og medlemmer med respekt og værdighed.",
    },
    {
      label: "Glæde",
      detail:
        "94 % af vores ungdomsmedlemmer bekræfter, at de er glade for at være i TFC.",
    },
  ],
  stats: [
    { value: "2006", label: "Sammenlagt" },
    { value: "1000+", label: "Medlemmer" },
    { value: "94%", label: "Tilfredshed (U)" },
    { value: "60+", label: "Hold & årgange" },
  ],
  historicPlayers: ["Jesper Lindstrøm", "Tony Adamsen", "Julie Tavlo"],
};

export const PITCHES = [
  {
    id: "bane-1",
    name: "Bane 1 — Opvisning",
    surface: "Naturgræs",
    size: "105 × 68 m",
    light: true,
    status: "Åben",
    usage: "Hjemmebane — Herresenior 1 & Kvinder",
  },
  {
    id: "bane-2",
    name: "Bane 2",
    surface: "Naturgræs",
    size: "100 × 64 m",
    light: true,
    status: "Åben",
    usage: "Træning & kamp — U15-U19",
  },
  {
    id: "bane-3",
    name: "Bane 3 — Kunstgræs",
    surface: "Kunstgræs",
    size: "105 × 68 m",
    light: true,
    status: "Åben",
    usage: "Helårstræning & kamp",
  },
  {
    id: "bane-4",
    name: "Bane 4 — 8-mands",
    surface: "Naturgræs",
    size: "70 × 50 m",
    light: true,
    status: "Åben",
    usage: "U10–U13 + Veteran/Oldboys 8M",
  },
  {
    id: "bane-5",
    name: "Bane 5 — 5/7-mands",
    surface: "Kunstgræs",
    size: "40 × 25 m",
    light: true,
    status: "Åben",
    usage: "Mikrobold, U6–U9 + teknisk træning",
  },
  {
    id: "cafe-hojen",
    name: "Café Højen",
    surface: "Klubhus",
    size: "Mødelokaler",
    light: true,
    status: "Åben",
    usage: "Klubliv, kampdage & mødeudlejning",
  },
];

// Repræsentativ uge — de officielle planer vedligeholdes kvartalsvist
// af Turneringsudvalget (PDF). Træner-navne er hentet fra ledere-og-traenere.
export const TRAINING = [
  // Senior
  {
    team: "Herresenior 1",
    day: "Tirsdag",
    time: "19:00 – 20:30",
    pitch: "Bane 1",
    coach: "Morten L. Albrechtsen",
  },
  {
    team: "Herresenior 1",
    day: "Torsdag",
    time: "19:00 – 20:30",
    pitch: "Bane 1",
    coach: "Morten L. Albrechtsen",
  },
  {
    team: "Herresenior 2",
    day: "Tirsdag",
    time: "19:00 – 20:30",
    pitch: "Bane 2",
    coach: "Jimmi Aasberg",
  },
  {
    team: "Herresenior 2",
    day: "Torsdag",
    time: "19:00 – 20:30",
    pitch: "Bane 2",
    coach: "Jimmi Aasberg",
  },
  {
    team: "Herresenior 3",
    day: "Mandag",
    time: "19:00 – 20:30",
    pitch: "Bane 3",
    coach: "Peter Hindse",
  },
  // Ungdom Drenge
  {
    team: "U19 Drenge",
    day: "Mandag",
    time: "18:00 – 19:30",
    pitch: "Bane 3",
    coach: "William Olaf Dalí",
  },
  {
    team: "U19 Drenge",
    day: "Onsdag",
    time: "18:00 – 19:30",
    pitch: "Bane 3",
    coach: "William Olaf Dalí",
  },
  {
    team: "U17 Drenge",
    day: "Tirsdag",
    time: "17:30 – 19:00",
    pitch: "Bane 2",
    coach: "Muzaffer Celik",
  },
  {
    team: "U17 Drenge",
    day: "Torsdag",
    time: "17:30 – 19:00",
    pitch: "Bane 2",
    coach: "Muzaffer Celik",
  },
  {
    team: "U15 Drenge",
    day: "Mandag",
    time: "17:00 – 18:30",
    pitch: "Bane 3",
    coach: "Stefan D. Fjordholt",
  },
  {
    team: "U14 Drenge",
    day: "Onsdag",
    time: "17:00 – 18:30",
    pitch: "Bane 2",
    coach: "Thomas Månsson",
  },
  {
    team: "U13 Drenge",
    day: "Tirsdag",
    time: "17:00 – 18:15",
    pitch: "Bane 4",
    coach: "Christian S. Nørgaard",
  },
  {
    team: "U12 Drenge",
    day: "Mandag",
    time: "16:45 – 18:00",
    pitch: "Bane 4",
    coach: "Rasmus Melsø",
  },
  {
    team: "U11 Drenge",
    day: "Tirsdag",
    time: "16:30 – 17:45",
    pitch: "Bane 4",
    coach: "Rune B. Nielsen",
  },
  {
    team: "U10 Drenge",
    day: "Onsdag",
    time: "16:30 – 17:45",
    pitch: "Bane 5",
    coach: "Mikael Mortensen",
  },
  {
    team: "U9 Drenge",
    day: "Mandag",
    time: "16:30 – 17:30",
    pitch: "Bane 5",
    coach: "Rasmus K. Krogstrup",
  },
  {
    team: "U7 Drenge",
    day: "Torsdag",
    time: "16:30 – 17:30",
    pitch: "Bane 5",
    coach: "Rasmus K. Krogstrup",
  },
  {
    team: "U6 / Mikrobold",
    day: "Lørdag",
    time: "10:00 – 11:00",
    pitch: "Bane 5",
    coach: "Finn B. Galthéen",
  },
  // Piger / Kvinder
  {
    team: "U19 Piger",
    day: "Mandag",
    time: "18:30 – 20:00",
    pitch: "Bane 2",
    coach: "Tina Kongsted (TL)",
  },
  {
    team: "U16 Piger",
    day: "Tirsdag",
    time: "17:30 – 19:00",
    pitch: "Bane 3",
    coach: "Mikael K. Mieritz",
  },
  {
    team: "U14 Piger",
    day: "Onsdag",
    time: "17:00 – 18:30",
    pitch: "Bane 3",
    coach: "Phillip B. Christensen",
  },
  {
    team: "U12 Piger",
    day: "Mandag",
    time: "17:00 – 18:15",
    pitch: "Bane 4",
    coach: "Phillip B. Christensen",
  },
  // Veteran / Fitness
  {
    team: "Oldboys 8M",
    day: "Onsdag",
    time: "19:30 – 21:00",
    pitch: "Bane 4",
    coach: "Ronni Broder (HL)",
  },
  {
    team: "Superveteran 8M",
    day: "Mandag",
    time: "19:30 – 21:00",
    pitch: "Bane 4",
    coach: "Morten H. Hansen (HL)",
  },
  {
    team: "Fodbold Fitness — Herrer",
    day: "Tirsdag",
    time: "19:00 – 20:30",
    pitch: "Bane 4",
    coach: "Finn Rasmussen (HL)",
  },
  {
    team: "Fodbold Fitness — Kvinder",
    day: "Torsdag",
    time: "19:00 – 20:00",
    pitch: "Bane 5",
    coach: "Henriette Monrad (HL)",
  },
  {
    team: "TFC Demens — Motion for livet",
    day: "Onsdag",
    time: "10:00 – 11:00",
    pitch: "Bane 5",
    coach: "Stig Schyberg",
  },
];

export const TEAMS = [
  {
    id: "herresenior-1",
    name: "Herresenior 1",
    league: "Danmarksserien",
    coach: "Morten L. Albrechtsen",
    assistant: "Kim K. Jacobsen",
    squadSize: 24,
  },
  {
    id: "herresenior-2",
    name: "Herresenior 2",
    league: "Sjællandsserien",
    coach: "Jimmi Aasberg",
    assistant: "Peter Rasmussen",
    squadSize: 22,
  },
  {
    id: "herresenior-3",
    name: "Herresenior 3",
    league: "Serie 1",
    coach: "Peter Hindse",
    assistant: "Martin L. Albrechtsen",
    squadSize: 20,
  },
  {
    id: "u19-drenge",
    name: "U19 Drenge",
    league: "Liga / Talent",
    coach: "William Olaf Dalí",
    assistant: "Peter H. Esbensen",
    squadSize: 26,
  },
  {
    id: "u17-drenge",
    name: "U17 Drenge",
    league: "Talenthold",
    coach: "Muzaffer Celik",
    assistant: "René Jørgensen",
    squadSize: 22,
  },
  {
    id: "u15-drenge",
    name: "U15 Drenge",
    league: "Talenthold",
    coach: "Stefan D. Fjordholt",
    assistant: "Lars Marcussen",
    squadSize: 20,
  },
  {
    id: "u14-drenge",
    name: "U14 Drenge",
    league: "Række 1",
    coach: "Thomas Månsson",
    assistant: "Mik Nielsen",
    squadSize: 18,
  },
  {
    id: "u13-drenge",
    name: "U13 Drenge",
    league: "Række 1",
    coach: "Christian S. Nørgaard",
    assistant: "Zacharias Vilain",
    squadSize: 18,
  },
  {
    id: "u12-drenge",
    name: "U12 Drenge",
    league: "Børnefodbold",
    coach: "Rasmus Melsø",
    assistant: "Kasper C. Bruzelius",
    squadSize: 17,
  },
  {
    id: "u11-drenge",
    name: "U11 Drenge",
    league: "Børnefodbold",
    coach: "Rune B. Nielsen",
    assistant: "Jesper S. Kaiser",
    squadSize: 18,
  },
  {
    id: "u10-drenge",
    name: "U10 Drenge",
    league: "Børnefodbold",
    coach: "Mikael Mortensen",
    assistant: "Andreas Langaa",
    squadSize: 20,
  },
  {
    id: "u9-drenge",
    name: "U9 Drenge",
    league: "Børnefodbold",
    coach: "Rasmus K. Krogstrup",
    assistant: "Nicki D. Søderhamn",
    squadSize: 22,
  },
  {
    id: "u8-drenge",
    name: "U8 Drenge",
    league: "Børnefodbold",
    coach: "Dannie Adamsen",
    assistant: "Rasmus C. Stilbo",
    squadSize: 24,
  },
  {
    id: "u6-mikro",
    name: "U6 / Mikrobold",
    league: "Mikro",
    coach: "Finn B. Galthéen",
    assistant: "Nikolaj Hamburger",
    squadSize: 18,
  },
  {
    id: "u19-piger",
    name: "U19 Piger",
    league: "Pige-/Kvindefodbold",
    coach: "Ronni S. Petersen",
    assistant: "Tina Kongsted",
    squadSize: 16,
  },
  {
    id: "u16-piger",
    name: "U16 Piger",
    league: "Pige-/Kvindefodbold",
    coach: "Mikael K. Mieritz",
    assistant: "René M. Sørensen",
    squadSize: 15,
  },
  {
    id: "u14-piger",
    name: "U14 Piger",
    league: "Talent — Piger",
    coach: "Phillip B. Christensen",
    assistant: "Kristian Graversen",
    squadSize: 16,
  },
  {
    id: "u12-piger",
    name: "U12 Piger",
    league: "Pigefodbold",
    coach: "Phillip B. Christensen",
    assistant: "Mia T. Nielsen",
    squadSize: 14,
  },
  {
    id: "oldboys-8m",
    name: "Oldboys 8M",
    league: "M+32",
    coach: "Ronni Broder (HL)",
    assistant: "—",
    squadSize: 18,
  },
  {
    id: "superveteran-8m",
    name: "Superveteran 8M",
    league: "M+50",
    coach: "Morten H. Hansen (HL)",
    assistant: "—",
    squadSize: 16,
  },
  {
    id: "fitness-herrer",
    name: "Fodbold Fitness — Herrer",
    league: "Fitness",
    coach: "Finn Rasmussen (HL)",
    assistant: "—",
    squadSize: 20,
  },
  {
    id: "tfc-demens",
    name: "TFC Demens — Motion for livet",
    league: "Motion",
    coach: "Stig Schyberg",
    assistant: "Steen Hartvig",
    squadSize: 12,
  },
];

// Repræsentative kommende kampe og resultater for Herresenior 1.
export const MATCHES = [
  {
    id: "m1",
    date: "2026-04-12",
    time: "15:00",
    home: "Taastrup FC",
    away: "Brønshøj BK",
    venue: "Nybolig Park",
    type: "kamp",
    competition: "Danmarksserien",
  },
  {
    id: "m2",
    date: "2026-04-19",
    time: "14:00",
    home: "HIK",
    away: "Taastrup FC",
    venue: "Hellerup",
    type: "kamp",
    competition: "Danmarksserien",
  },
  {
    id: "m3",
    date: "2026-04-26",
    time: "15:00",
    home: "Taastrup FC",
    away: "B.93",
    venue: "Nybolig Park",
    type: "kamp",
    competition: "Danmarksserien",
  },
  {
    id: "r1",
    date: "2026-04-02",
    time: "15:00",
    home: "Taastrup FC",
    away: "Avarta",
    venue: "Nybolig Park",
    type: "resultat",
    result: { home: 3, away: 1 },
    competition: "Danmarksserien",
    label: "En sejr for hele TFC",
  },
  {
    id: "r2",
    date: "2026-03-22",
    time: "14:00",
    home: "Fremad Amager",
    away: "Taastrup FC",
    venue: "Sundby",
    type: "resultat",
    result: { home: 1, away: 2 },
    competition: "Danmarksserien",
  },
  {
    id: "r3",
    date: "2026-03-15",
    time: "15:00",
    home: "Taastrup FC",
    away: "Hvidovre IF 2",
    venue: "Nybolig Park",
    type: "resultat",
    result: { home: 0, away: 0 },
    competition: "Danmarksserien",
  },
];

// Rigtige overskrifter fra taastrupfc.com / nyheder / 2026
export const NEWS = [
  {
    id: "n1",
    title: "En sejr for hele TFC",
    excerpt:
      "Vores Herresenior 1 sikrede sig en stor 3-1 sejr i lokalopgøret — en præstation der løfter hele klubben.",
    date: "02. apr 2026",
    category: "Kamp",
    href: "https://www.taastrupfc.com/nyheder/tfc-nyheder/2026/en-sejr-for-hele-tfc/",
    image:
      "https://images.unsplash.com/photo-1583214499157-ce8d6f368fef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxzb2NjZXIlMjBwbGF5ZXIlMjBhY3Rpb24lMjBuaWdodCUyMHN0YWRpdW18ZW58MHx8fHwxNzc3MzYyNTAxfDA&ixlib=rb-4.1.0&q=85",
    featured: true,
  },
  {
    id: "n2",
    title: "Ny klubchef i Taastrup FC",
    excerpt:
      "Daniel Mølgaard tiltræder som fodbolddirektør og klubchef. Et stort skridt i den professionalisering, klubben har arbejdet hen imod.",
    date: "26. mar 2026",
    category: "Klub",
    href: "https://www.taastrupfc.com/nyheder/tfc-nyheder/2026/ny-klubchef-i-taastrup-fc/",
    image:
      "https://images.unsplash.com/photo-1621058567697-7673eef9ce28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMHBpdGNoJTIwbGluZXMlMjBkYXJrfGVufDB8fHx8MTc3NzM2MjUwMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "n3",
    title: "Få 20% rabat hos Unisport",
    excerpt:
      "Som medlem i Taastrup FC får du nu 20% rabat på alt udvalgt sportstøj hos Unisport.",
    date: "08. apr 2026",
    category: "Medlemsfordel",
    href: "https://www.taastrupfc.com/nyheder/tfc-nyheder/2026/faa-20-rabat-hos-unisport/",
    image:
      "https://images.unsplash.com/photo-1710788617743-8b9ed4143325?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxzb2NjZXIlMjBwbGF5ZXIlMjBhY3Rpb24lMjBuaWdodCUyMHN0YWRpdW18ZW58MHx8fHwxNzc3MzYyNTAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "n4",
    title: "Organisationsændring i Taastrup FC",
    excerpt:
      "Bestyrelsen præsenterer en organisationsændring, der skal styrke det sportslige og administrative fundament.",
    date: "16. feb 2026",
    category: "Klub",
    href: "https://www.taastrupfc.com/nyheder/tfc-nyheder/2026/organisationsaendring-i-taastrup-fc/",
    image:
      "https://static.prod-images.emergentagent.com/jobs/784dbb52-c333-452b-9dc0-e74e42a3174e/images/24c13a4e20bfe1717594dc8307e92bd939207bf3a33b8fae454905715051504d.png",
  },
];

export const CONTACTS = [
  {
    role: "Kontoret",
    name: "Taastrup FC",
    email: null,
    phone: "31 90 30 20",
  },
  {
    role: "Fodbolddirektør / Klubchef",
    name: "Daniel Mølgaard",
    email: "dm@taastrupfc.com",
    phone: null,
  },
  {
    role: "Bestyrelsesformand",
    name: "Formanden",
    email: "formand@taastrupfc.com",
    phone: null,
  },
  {
    role: "Bestyrelsessekretær",
    name: "Sekretæren",
    email: "sekretaer@taastrupfc.com",
    phone: null,
  },
  {
    role: "Pigeudvalg",
    name: "Pigeudvalget",
    email: "pigeudvalget@taastrupfc.com",
    phone: null,
  },
  {
    role: "Sportsligt udvalg",
    name: "Sportsudvalget",
    email: "sportsligtudvalg@taastrupfc.com",
    phone: null,
  },
];

export const NAV_LINKS = [
  { label: "Forside", href: "#hero" },
  { label: "Baneoversigt", href: "#baneoversigt" },
  { label: "Træning", href: "#traening" },
  { label: "Kampe", href: "#kampe" },
  { label: "Hold", href: "#hold" },
  { label: "Nyheder", href: "#nyheder" },
  { label: "Info", href: "#info" },
];
